/** Reading the value off a DOM event, for the handlers that can't use `bind:value`
 *  (a field written straight back to a store, rather than into local component state). */

export function inputValue(e: Event): string {
  return (e.currentTarget as HTMLInputElement).value;
}

export function selectValue(e: Event): string {
  return (e.currentTarget as HTMLSelectElement).value;
}

export function checkboxValue(e: Event): boolean {
  return (e.currentTarget as HTMLInputElement).checked;
}
